import { Fragment, useEffect, useState } from 'react';
import { formatNumber } from '../../../../../utils/formatacoes';
import DataTable from 'react-data-table-component';

const AdicoesTable = ({ processoData }) => {
  const [rows, setRows] = useState([]);

  const columns = [
    {
      id: 'adicao',
      name: 'Adição',
      width: '3.8vw',
      selector: (row) => row.adicao.toString().padStart(3, '0'),
    },
    {
      id: 'ncm',
      name: 'NCM',
      width: '5vw',
      selector: (row) => row.produto?.NcmsLigacoes?.codigo ?? '-',
    },
    {
      id: 'qtde_itens',
      name: 'Nº Itens',
      width: '4vw',
      selector: (row) => row.qtde_itens ?? '-',
    },
    {
      id: 'qtde_estat',
      name: 'Qtde. Estat.',
      selector: (row) => formatNumber(row.qtde_estat, 5) ?? '-',
    },
    {
      id: 'unid_estat',
      name: 'Unid. Estat.',
      selector: (row) => row.produto?.NcmsLigacoes?.unidade_medida?.sigla ?? '-',
    },
    {
      id: 'qtde_comerc',
      name: 'Qtde. Comerc.',
      selector: (row) => formatNumber(row.qtde_comerc) ?? '-',
    },
    {
      id: 'unid_comerc',
      name: 'Unid. Comerc.',
      selector: (row) => row.unid_comerc ?? '-',
    },
    {
      id: 'peso_liquido',
      name: 'Peso Líquido',
      selector: (row) => formatNumber(row.peso_liquido, 5) ?? '-',
    },
    {
      id: 'vmcv_moeda',
      name: 'VMCV',
      selector: (row) => (row.moeda?.simbolo ?? '') + ' ' + (formatNumber(row.vmcv_moeda) ?? '-'),
    },
    {
      id: 'vmle_moeda',
      name: 'VMLE',
      selector: (row) => (row.moeda?.simbolo ?? '') + ' ' + (formatNumber(row.vmle_moeda) ?? '-'),
    },
    {
      id: 'frete_real',
      name: 'Frete',
      selector: (row) => 'R$ ' + (formatNumber(row.frete_real) ?? '-'),
    },
    {
      id: 'seguro_moeda',
      name: 'Seguro',
      selector: (row) =>
        (processoData.taxas[processoData.seguro_moeda_id]?.simbolo ?? '') +
        ' ' +
        (formatNumber(row.seguro_moeda) ?? '-'),
    },
    {
      id: 'valor_aduaneiro',
      name: 'Valor Aduaneiro',
      selector: (row) => 'R$ ' + (formatNumber(row.valor_aduaneiro ?? 0) ?? '-'),
    },
    {
      id: 'ii',
      name: 'II A Recolher',
      width: '8vw',
      selector: (row) =>
        'R$ ' +
        (formatNumber(row.II_valor_recolher_real ?? 0) ?? '-') +
        ' (' +
        (formatNumber(row.II_aliquota_efetiva ?? 0) ?? '-') +
        '%)',
    },
    {
      id: 'ipi',
      name: 'IPI A Recolher',
      width: '8vw',
      selector: (row) =>
        'R$ ' +
        (formatNumber(row.IPI_valor_recolher_real ?? 0) ?? '-') +
        ' (' +
        (formatNumber(row.IPI_aliquota_efetiva ?? 0) ?? '-') +
        '%)',
    },
    {
      id: 'pis',
      name: 'PIS A Recolher',
      width: '8vw',
      selector: (row) =>
        'R$ ' +
        (formatNumber(row.PIS_valor_recolher_real ?? 0) ?? '-') +
        ' (' +
        (formatNumber(row.PIS_aliquota_efetiva ?? 0) ?? '-') +
        '%)',
    },
    {
      id: 'cofins',
      name: 'COFINS A Recolher',
      width: '8vw',
      selector: (row) =>
        'R$ ' +
        (formatNumber(row.COFINS_valor_recolher_real ?? 0) ?? '-') +
        ' (' +
        (formatNumber(row.COFINS_aliquota_efetiva ?? 0) ?? '-') +
        '%)',
    },
  ];

  useEffect(() => {
    if (!processoData) return;

    setRows(processoData.adicoes);
  }, [processoData]);

  return (
    <Fragment>
      <DataTable
        dense
        columns={columns}
        data={rows}
        pagination
        paginationPerPage={20}
        paginationComponentOptions={{
          noRowsPerPage: true,
          rangeSeparatorText: 'de',
        }}
      />
    </Fragment>
  );
};

export default AdicoesTable;
